import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { map } from "rxjs/operators";
import { AppSettings } from "../../proyect.conf";
import { UnidadMedidaCultivo } from "../_models/unidad-medida-cultivo";
import { AutenticacionService } from "./autenticacion.service";

@Injectable({
  providedIn: "root",
})
export class UnidadesMedidasCultivosService {
  private serviceURL =
    AppSettings.rutServiciosAPL + "/api/unidadesMedidasCultivos";

  constructor(
    private httpClient: HttpClient,
    private autServicio: AutenticacionService
  ) {}

  getAll() {
    return this.httpClient
      .get(this.serviceURL)
      .pipe(map((res) => res as UnidadMedidaCultivo[]));
  }

  get(id: string) {
    return this.httpClient
      .get(this.serviceURL + id)
      .pipe(map((res) => res as UnidadMedidaCultivo));
  }

  add(regCrear: UnidadMedidaCultivo) {
    regCrear.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httpClient
      .post(this.serviceURL, regCrear)
      .pipe(map((res) => res as UnidadMedidaCultivo));
  }

  update(regActualizar: UnidadMedidaCultivo) {
    regActualizar.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httpClient
      .put(this.serviceURL, regActualizar)
      .pipe(map((res) => res as UnidadMedidaCultivo));
  }

  getAllEnabled() {
    return this.httpClient
      .get(this.serviceURL + "enabled/")
      .pipe(map((res) => res as UnidadMedidaCultivo[]));
  }
}
